import { render, staticRenderFns } from "./KernelPackageReturn.vue?vue&type=template&id=a720e992&"
import script from "./KernelPackageReturn.vue?vue&type=script&lang=js&"
export * from "./KernelPackageReturn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports